import { render, staticRenderFns } from "./ChatVoiceMessage.vue?vue&type=template&id=563a9817&scoped=true"
import script from "./ChatVoiceMessage.vue?vue&type=script&lang=js"
export * from "./ChatVoiceMessage.vue?vue&type=script&lang=js"
import style0 from "./ChatVoiceMessage.vue?vue&type=style&index=0&id=563a9817&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "563a9817",
  null
  
)

export default component.exports